import { Col, Row } from "antd"


export const pageWrapper = (formsRender, id) => {
    const route = window.location.pathname === `/patient-info/${id}`
    if (route) {
        return <div>{formsRender()}</div>
    }
    else {
        return (
            <Row justify={'center'}>
                <Col xs={24} md={18}>
                    {formsRender()}
                </Col>
            </Row>
        )
    }
}